import { gql } from '@apollo/client';
import { EntityNoteFragment } from '../fragments/EntityNoteFragment';
/**
 * @const EntityNotesQuery
 * @since 1.0.0
 */
export const EntityNotesQuery = gql `
  query EntityNotesQuery($input: EntityNotesInput!) {
    entityNotes(input: $input) {
      ...EntityNoteFragment
    }
  }

  ${EntityNoteFragment}
`;
